<template>
  <page-with-aside :hasFooter="true">
    <template #navheader>
      <site-header></site-header>
    </template>

    <template #content>
      <section class="content">
        <h2>Study Eligibility</h2>
        <h4>Thank you for your interest in Open to Options.</h4>

        <p>
          Open to Options is most helpful when you are preparing to see a cancer
          doctor soon.
          <strong>
            Please come back when you have an appointment scheduled within 3
            weeks.
          </strong>
          You can use the same access code when you return. Thank you!
        </p>
      </section>
    </template>
  </page-with-aside>
</template>

<script>
import PageWithAside from "@/components/PageWithAside.vue";
import SiteHeader from "@/components/siteHeader.vue";

export default {
  name: "IneligiblePending",

  components: {
    "site-header": SiteHeader,
    PageWithAside,
  },
};
</script>